<template>
  <div :class="['tag-input', (!value || !value.length) && isClickOne && !focusBorder?'isEmpty':'', {'disabled':disabled, 'focusBorder': focusBorder}]" ref="tagInput" @click="clickInput">
    <div class="err-empty">{{placeholder == '请选择'?'请选择查询条件':'请输入查询条件'}}</div>
    <div class="tag" ref="tag">
      <!-- <transition name="el-zoom-in-center"> -->
      <span class="textOverflow" v-for="(item, index) in value" :key="index" :title="item.label">
        {{ item.label }}
        <i class="el-icon-close" v-if="!disabled" @click.stop="clickRemove(index)" />
      </span>
      <!-- </transition> -->
      <input class="t-input" v-model="word" :disabled="disabled" :placeholder="value.length?'':placeholder" @keydown.enter="clickEnter" @keyup.186="clickEnter" @input="change" @focus="getFocus"
        @blur="getBlur" />
    </div>
  </div>
</template>

<script>
export default {
  inject:['$_search'],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '单个词不超过30个字符;最多20个词;回车键隔开'
    },
    index: {
      type: Number,
      default: -1
    },
    // 改为复杂数组方便做id区分
    value: {
      type: Array,
      default: () => []
    },
    allowEnter: {
      type: Boolean,
      default: true
    },
    maxValue: {
      type: Number,
      default: 20
    },
    typeInput:{
      type:String,
      default:()=>''
    }
  },
  data() {
    return {
      word: '',
      isClickOne: false,
      focusBorder: false
    }
  },
  mounted() {
    this.$_search.$on('search',(e)=>{
      this.isClickOne = true
      console.log('------點擊搜索啦啦啦啦-----')
    })
  },
  methods: {
    change(e) {
      // e.data
      this.$emit('change', this.word)
    },
    // border内任意处获取焦点
    clickInput(e) {
      this.isClickOne = true
      if (e.target.tagName === 'DIV') {
        e.target.children[e.target.children.length - 1].focus()
      }
    },
    // 获取焦点
    getFocus() {
      this.setBorderColor()
      this.$emit('getFocus', this.index)
    },
    // 失去焦点
    getBlur() {
      this.removeBorderColor()
      this.clickEnter()
      this.word = ''
      this.$emit('getBlur')
    },
    // 判断上限
    isMax() {
      if (this.maxValue) {
        if (this.value.length >= this.maxValue) {
          this.$message.warning('已经添加到上限')
          return true
        }
      }
      return false
    },
    // 添加tag事件
    addItem(val) {
      let str = val
      if (typeof val !== 'string') {
        str = val.label
      }
      if(str.includes('、') || str.includes('，')){
        const item = str.includes('、') ? str.split('、'): str.split('，')
          if(item){
            item.forEach(v => {
                v = v.trim().replace(/\.*;/g, '').replace(' ', '')
                if(this.value.findIndex(e =>e.label === v) === -1){
                     if (this.isMax()) return
                    this.value.push({ label: v.substr(0,30), value: v.substr(0,30)})
                    this.$emit('afterAdd')
                }
            });
          }
      }else{
          const item = str.trim().replace(/\.*;/g, '').replace(' ', '')
          if (item && this.value.findIndex(e => e.label === item) === -1) {
            if (this.isMax()) return
            this.value.push({ label: item.substr(0, 30), value: val.value || item.substr(0, 30) })
            this.$emit('afterAdd')
          }
      }
    },
    // todo 测试
    removeItem(val) {
      const index = this.value.findIndex(e => e.value === val)
      if (index !== -1) {
        this.clickRemove(index)
      }
    },
    clickRemove(index) {
      this.value.splice(index, 1)
      this.$emit('deleteTag')
    },
    clickEnter() {
      // 触发地址选择状态
      // if(this.typeInput == 'area'){
      //    this.$emit('getAreaVal',this.word)
      //    return
      // }
      if (this.allowEnter) {
        this.addItem(this.word)
        this.$emit('clickEnter', this.word)
      }
      this.word = ''
    },
    getStyle() {
      var height = 40
      return {
        'min-height': height + 'px'
      }
    },
    setBorderColor() {
      this.focusBorder = true
    },
    removeBorderColor() {
      this.focusBorder = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tag-input {
  display: inline-block;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  vertical-align: middle;
  padding: 0px 10px;
  width: 100%;
  box-sizing: border-box;
  &.disabled {
    cursor: no-drop;
    background-color: #f5f7fa;
    border-color: #e4e7ed;
    color: #c0c4cc;
  }
  .tag {
    line-height: normal;
    white-space: normal;
    z-index: 1;
    // margin-top: 1px;

    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 2px 0;
    box-sizing: border-box;
    span {
      background: #F0F2F5;
      color: #5A5E66;
      font-size: 12px;
      margin: 3px 3px 3px 0;
      border-radius: 3px;
      padding: 0px 28px 0px 10px;
      position: relative;
      box-sizing: border-box;
      height: 24px;
      line-height: 25px;
      // display: flex;
      // align-items: center;
      i {
        cursor: pointer;
        padding: 0px;
        // margin-left: 4px;
        position: absolute;
        // top: 4px;
        right: 8px;
        top: 0;
        bottom: 0;
        margin: auto;
        &.el-icon-close{
           &:hover{
             transform: rotate(0deg);
           }
        }
      }
      &.spanerr {
        background-color: #ffeaea;
        border: solid 1px #edb8b8;
        color: red;
        i {
          background: #edb8b8;
        }
      }
    }
    input {
      margin-bottom: 1px;
      outline: 0;
      padding: 0;
      color: #666;
      font-size: 14px;
      -webkit-appearance: none;
      height: 28px;
      background-color: transparent;
      flex-grow: 1;
      width: 50px;
      max-width: 100%;
      border: none;
      box-shadow: none;
    }
  }

  &.focusBorder {
    border: 1px solid #409eff;
  }
  // .t-input {
  //   &:focus .tag-input{
  //   }
  // }
}
input::-webkit-input-placeholder {
  color: rgb(194, 199, 206);
  font-size: 12px;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: rgb(194, 199, 206);
  font-size: 12px;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgb(194, 199, 206);
  font-size: 12px;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: rgb(194, 199, 206);
  font-size: 12px;
}

.tag-input {
  .tag{
    span i{
         width: 12px;
          height: 12px;
        &.el-icon-close:before{
          font-size: 12px;
          background: #C0C4CC;
          border-radius: 50%;
          color:  #FFFFFF;
        }
    }
      
  }
}

.err-empty{
  display: none;
}
.isEmpty{
  position: relative;
  border: 1px solid #F56C6C;
  transition: all 0.3s;
  .err-empty{
    display: block;
    font-size: 12px;
    color: #F56C6C;
    position: absolute;
    z-index: 11;
    bottom: -18px;
    left: 0;
  }
}
</style>
